import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ExcelService } from '@store';
import { StatistikYdelser } from '../../models/StatistikYdelser';
import { IndexCard, User } from '../../../auth/store/models';
import { firstDayThisMonth, lastDayThisMonth } from '../../../shared/month-picker/month-picker.helper';
import { V2Ydelser } from '../../../clients/client-details/store/models';
import { YdelseTimerKronerPipe } from './ydelse-timer-kroner.pipe';
import { saveAs } from 'file-saver';

@Component({
    selector: 'app-statistik-ydelse-ui',
    templateUrl: './statistik-ydelse.component.html',
    styleUrls: ['./statistik-ydelse.component.scss'],
    providers: [YdelseTimerKronerPipe],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StatistikYdelseComponent implements OnInit, OnChanges {
    @Input() laCards: IndexCard[];
    @Input() kaCards: IndexCard[];
    @Input() saCards: IndexCard[];
    @Input() kundelistWithYdelser: StatistikYdelser[];
    @Input() ydelserList: V2Ydelser[];
    @Input() periode: {fra: string, til: string};
    @Input() user: User | undefined;
    @Input() laID: number;
    @Input() kaID: number;
    @Input() saID: number;
    @Output() periodeChange = new EventEmitter<{fra: string, til: string}>();
    @Output() laChange = new EventEmitter<number>();
    @Output() kaChange = new EventEmitter<number>();
    @Output() saChange = new EventEmitter<number>();

    filteredYdelserList: V2Ydelser[];
    hourFormat = 'Timer';

    constructor(
        private excel: ExcelService,
        private ydelseTimerKroner: YdelseTimerKronerPipe,
    ) { }

    ngOnInit() {
        const newPeriode = {
            fra: firstDayThisMonth(),
            til: lastDayThisMonth()
        };
        this.onPeriodeChange(newPeriode);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.user && this.user) {
            const iCard = this.user.indexCard;
            if (iCard.ledelsesansvarlig) {
                this.onLedelseAnsvarligSelected(iCard.cardId);
            }
            if (iCard.kundeansvarlig && !iCard.ledelsesansvarlig) {
                this.onKundeAnsvarligSelected(iCard.cardId);
            }
            if (iCard.sagsbehandler && !iCard.kundeansvarlig && !iCard.ledelsesansvarlig) {
                this.onSagsAnsvarligeSelected(iCard.cardId);
            }
        }
        if (this.kundelistWithYdelser && this.ydelserList) {
            this.filteredYdelserList = [...this.ydelserList, {id: null, navn: 'Legacy ydelser'}];
            this.filteredYdelserList = this.filteredYdelserList.filter(y => this.totalByYdelse(y.id) !== 0);
        }
    }

    getTotalOfKunde(kunde: StatistikYdelser): number {
        if (this.hourFormat === 'Timer') {
            return kunde.ydelser.reduce((acc, curr) => acc + curr.timer, 0);
        }
        return kunde.ydelser.reduce((acc, curr) => acc + curr.kroner, 0);
    }

    onPeriodeChange(periode: {fra: string; til: string}) {
        this.kundelistWithYdelser = [];
        this.periodeChange.emit(periode);
    }

    TotalOfTotals() {
        let total = 0;
        this.kundelistWithYdelser?.forEach(kunde => {
            total += this.getTotalOfKunde(kunde);
        });
        return Math.round(total);
    }

    onLedelseAnsvarligSelected($event: number) {
        this.laChange.emit($event);
    }

    onKundeAnsvarligSelected($event: number) {
        this.kaChange.emit($event);
    }

    onSagsAnsvarligeSelected($event: number) {
        this.saChange.emit($event);
    }

    onHourFormatSelected($event) {
        this.hourFormat = $event;
    }

    totalByYdelse(id: number) {
        if (this.hourFormat === 'Timer') {
            return this.kundelistWithYdelser?.reduce((acc, curr) => acc + curr.ydelser.find(y => y.v2YdelserId === id).timer, 0);
        }
        return this.kundelistWithYdelser?.reduce((acc, curr) => acc + curr.ydelser.find(y => y.v2YdelserId === id).kroner, 0);
    }

    onExport() {
        const exportArray = [
            ['Kundenr.', 'Kunde', ...this.filteredYdelserList.map(y => y.navn), 'Total', ''],
            ...this.kundelistWithYdelser.map(kunde => [
                kunde.glKundeNr,
                kunde.kunde,
                ...this.filteredYdelserList.map(y => this.ydelseTimerKroner.transform(kunde.ydelser, y.id, this.hourFormat)),
                this.getTotalOfKunde(kunde),
            ])
        ];
        this.excel.generateExcel(exportArray).subscribe((blob: Blob) => {
            saveAs(blob, 'statistik-ydelse.xlsx');
        });
    }
}
